import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as ErrorIcon } from '@/img/error/broken-link.svg';
import './ThemeLoadingError.scss';

function ThemeLoadingError() {
    const { t } = useTranslation();

    return (
        <div className="theme-loading-error">
            <div className="theme-loading-error__container">
                <div className="theme-loading-error__icon-wrap">
                    <ErrorIcon />
                </div>
                <div className="theme-loading-error__title">Oops! Something went wrong</div>
                <div className="theme-loading-error__message">
                    Our team has been notified and is working to resolve this. Please try again later.
                </div>
            </div>
        </div>
    );
}

export default ThemeLoadingError;
